module.exports = __webpack_public_path__ + "static/media/Silver.31b56996.png";